import { useQuery } from "@tanstack/react-query";
import {
  getRequestContractQueryOptions,
  mapDimCodeNameToSelectOption,
} from "./getRequestContractQueryOptions";

const useGetRequestContractSalesTerms = (
  cardCode: string | undefined,
  itemCode: string | undefined
) =>
  useQuery({
    ...getRequestContractQueryOptions(cardCode, itemCode),
    enabled: cardCode !== undefined && itemCode !== undefined,
    select: ({ data }) => data?.SalesTerms?.map(mapDimCodeNameToSelectOption),
  });

export default useGetRequestContractSalesTerms;
